<ng-scrollbar class="global-container" appearance = "compact" #scrollable pointerEventsMethod="scrollbar">   
    <div class="d-flex row">
        <img src = "../../../assets/error-img.jpg"/>
    </div>
</ng-scrollbar>

